<template>
  <CalculatorApplicationOnHold v-if="isCalculatorApplicant" />
  <div class="row" v-else>
    <div class="col-12 col-md-4">
      <ProgressSteps :step="4"></ProgressSteps>
    </div>
    <div class="col-12 col-md-8">
      <div class="q-pa-md border-radius-top q-pt-md-none">
        <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded">
          <div class="col-12">
            <div style="text-align: center; padding-top: 40px; padding-bottom: 40px">
              <img src="/assets/images/group2.svg" />
            </div>
            <div class="q-px-lg q-py-lg">
              <MainHeadline
                align="center"
                header="Your application will be submitted once Authorised Officer (2) completes their ID scan"
                body="Please contact Authorised Officer (2) to accelerate this process and once complete you will be notified via email on how to proceed."
              />
            </div>
            <div v-if="isSecondaryApplicantDone" class="q-px-lg q-py-lg" style="text-align: center">
              <QBtn :loading="loading" color="primary" outline no-caps @click="onSubmitCreditCheck()">Resubmit Application</QBtn>
            </div>
            <div v-else class="q-px-lg q-py-lg" style="text-align: center">
              <QBtn color="primary" outline no-caps @click="onClickHandler()">Log Out</QBtn>
            </div>
            <MoreInfoBlock />
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import { mapState, mapGetters } from 'vuex';
import ProgressSteps from '../../components/Molecules/ProgressSteps';
import MainHeadline from '../../components/Atoms/MainHeadline';
import MoreInfoBlock from '../../components/Atoms/MoreInfoBlock';
import CalculatorApplicationOnHold from '@/pages/CalculatorAuth/Approvals/ApplicationOnHold';
import MutateSubmitCreditCheck from '@/graphql/mutations/MutateSubmitCreditCheck';
import { GLOBAL_ERROR } from '@/components/GlobalError/GlobalError';
import MyCustomFunctions from '@/mixins/MyCustomFunctions';

export default {
  name: 'Review',
  mixins: [MyCustomFunctions],
  components: { QBtn, MainHeadline, MoreInfoBlock, ProgressSteps, CalculatorApplicationOnHold },
  props: [],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    ...mapGetters({
      calculatorApplicant: 'vehicleApplication/isCalculatorApplicant'
    }),
    isCalculatorApplicant() {
      return this.calculatorApplicant;
    },
    isSecondaryApplicantDone() {
      return (
        this.scoreboard.secondaryApplicant.identityVerificationStatus === 'completed' && this.scoreboard.statusCreditCheck === 'waiting'
      );
    }
  },
  created() {},
  data: function () {
    return {
      loading: false
    };
  },
  methods: {
    onSubmitCreditCheck: async function () {
      this.loading = true;
      await this.$apollo
        .mutate({
          mutation: MutateSubmitCreditCheck,
          variables: {
            payload: {
              applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
                ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
                : null
            }
          }
        })
        .then(async (data) => {
          if (data?.data?.submitCreditCheck?.result) {
            var resultValue = 'refer';
            await this.updateVehicleApplication(resultValue, 'statusCreditCheck');
          }
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loading = false;
    },
    onClickHandler: function () {
      this.loading = true;
      this.$router.push({ name: 'logout' });
      this.loading = false;
    }
  }
};
</script>
